
export const RUFUS_ANALYSIS_PROMPT = `你是一位亚马逊资深运营专家。请基于以下采集自 Amazon Rufus 的买家问答数据（Q&A），分析 ASIN: {{asin}}。

### 1. 原始问答数据 (Source Data)
{{qa_text}}

---

### 2. 分析指令 (Analysis Instructions)

**⚠️ 格式强制要求 (CRITICAL FORMATTING RULES)：**
1. **表格格式**：必须严格遵循 Markdown 表格语法。**表格的每一行（包括表头、分隔线、数据行）必须单独占一行，严禁合并在同一行。**
   * 正确示例：
     | 词汇 | 频次 |
     | :--- | :--- |
     | A | 10 |
   * 错误示例：| 词汇 | 频次 | | :--- | :--- | | A | 10 |
2. **禁止废话**：**不要输出"前言"、"综述"、"根据数据..."等废话。直接输出第0章的标题。**
3. **完整性**：必须完整输出所有 10 个章节。

### 3. 报告章节要求 (Report Structure)

请严格按以下结构输出 Deep Dive Report：

0. 📊 **数据统计 (Data Statistics)**
   - **高频词云**：提取 Top 10 关键词。**务必使用标准 Markdown 表格，每行数据换行。**
     | 词汇 | 频次 | 关联意图 |
     | :--- | :--- | :--- |
     | ... | ... | ... |
   - **意图分布**：百分比估算。

1. 📉 **Listing 信息缺失诊断 (Information Gaps)**
   - 找出 Listing 未明确展示的信息。
   - **详细列出**：具体缺失点。

2. 🎯 **用户画像与长尾场景挖掘 (User Personas & Scenarios)**
   - **详细列出**：每一个具体场景（如"给5岁孩子当礼物"）。

3. 🚧 **转化障碍与顾虑 (Conversion Barriers)**
   - **详细列出**：阻碍下单的核心疑虑。

4. 💡 **产品迭代与研发灵感 (R&D Ideas)**
   - **详细列出**：功能改进需求。

5. 🔗 **关联销售与捆绑机会 (Cross-selling)**
   - **详细列出**：配件或互补品建议。

6. 🔍 **SEO 语义词库 (Semantic Keywords)**
   - **详细列出**：买家口语化搜索词。

7. ⚔️ **竞品/品牌信号 (Competitor/Brand Signals)**
   - 分析 Rufus 对品牌的语气。

8. 🤖 **AI 推荐截流策略 (GEO / AI Optimization)**
   - **核心目标**：生成 15-20 组诱导 Rufus 推荐的 Q&A 对。
   - **格式**：Markdown 列表或表格。

9. 🎯 **主动探测深度验证 (Active Probing Analysis)**
   - **识别**：分析用户主动输入的探测问题（通常在数据末尾）。
   - **验证**：Rufus 是否推荐？是否承认痛点？
   - **结论**：我们的假设是否成立。

请立即开始输出报告正文：
`;
